import React from 'react';
import { useTranslation } from 'react-i18next';
import { DataTable } from 'grommet';
import { Box, DataTableHeader, DataTableItem, LoadingSpinner, Text } from '/src/components';
import { ClientProgram } from '/src/lib/models';
import { getPeriodFromDateString } from '/src/utils';

export type ProgramCommissionsListProps = {
  clientPrograms?: ClientProgram[];
  isYearly?: boolean;
};

export const ProgramCommissionsList: React.FC<ProgramCommissionsListProps> = ({ clientPrograms, isYearly = false }) => {
  const { t } = useTranslation();

  return !clientPrograms ? (
    <LoadingSpinner />
  ) : (
    <DataTable
      pad={{ horizontal: '1.5rem' }}
      columns={[
        {
          property: 'name',
          header: <DataTableHeader>{t('common:program')}</DataTableHeader>,
          primary: true,
          size: '35%',
          render: (clientProgram) => <Text>{clientProgram.program.name}</Text>,
        },
        {
          property: 'percent_rate',
          size: '16%',
          header: <DataTableHeader>{t('commissions:percentage')}</DataTableHeader>,
          render: (clientProgram) => (
            <DataTableItem boxProps={{ pad: { vertical: '1rem' } }}>
              {clientProgram.percent_rate ? `${clientProgram.percent_rate}%` : '—'}
            </DataTableItem>
          ),
        },
        {
          property: 'fixed_kwh_rate',
          size: '16%',
          header: <DataTableHeader>{t('commissions:fixedRate')}</DataTableHeader>,
          render: (clientProgram) => (
            <DataTableItem boxProps={{ pad: { vertical: '1rem' } }}>
              {clientProgram.fixed_kwh_rate ? (
                <Box row gap="xsmall">
                  <Text>${`${clientProgram.fixed_kwh_rate}`}</Text>
                  <Text>/ kWh</Text>
                </Box>
              ) : (
                '—'
              )}
            </DataTableItem>
          ),
        },
        {
          property: 'start_reporting_quarter',
          size: '16%',
          header: <DataTableHeader>{t('commissions:effectiveStartDate')}</DataTableHeader>,
          render: (clientProgram) => (
            <DataTableItem>{getPeriodFromDateString(clientProgram.start_reporting_quarter, isYearly)}</DataTableItem>
          ),
        },
        {
          property: 'end_reporting_quarter',
          size: '16%',
          header: <DataTableHeader>{t('commissions:effectiveEndDate')}</DataTableHeader>,
          render: (clientProgram) => (
            <DataTableItem>
              {clientProgram.end_reporting_quarter === '2999-10-01' ? (
                '—'
              ) : (
                <Text>{getPeriodFromDateString(clientProgram.end_reporting_quarter, isYearly)}</Text>
              )}
            </DataTableItem>
          ),
        },
      ]}
      data={clientPrograms}
      background={['light-6', 'white']}
    />
  );
};
